<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>子商户报件</h1>
        <p>该接口报件完成后，调用图片上传接口上传图片资料</p>
        <p>
          第一步基本资料上传，【
          <router-link tag="span" :to="{path:'/interface/zshbj'}" class="cursor-pointer color-black-1" type="span">子商户报件</router-link>
          <router-link tag="span" :to="{path:'/interface/tpsc'}" class="cursor-pointer color-black-1" type="span">图片上传</router-link>
          】【必须】<br />
          第二步提交报备【
          <router-link tag="span" :to="{path:'/interface/zshktcp'}" class="cursor-pointer color-black-1" type="span">子商户开通产品</router-link>
          <router-link tag="span" :to="{path:'/interface/zshcx'}" class="cursor-pointer color-black-1" type="span">子商户开通产品查询</router-link>
          】【必须】<br />
          第三步【
          <router-link tag="span" :to="{path:'/interface/zshfzxy'}" class="cursor-pointer color-black-1" type="span">子商户分账协议签署</router-link>
          】【若不需要分账可以忽略】<br />
          第四步报备商户的微信支付目录、appid 【
          <router-link tag="span" :to="{path:'/interface/zshpz'}" class="cursor-pointer color-black-1" type="span">子商户业务配置</router-link>
          】【若不需要微信支付可以忽略】<br />
          第五步【
          <router-link tag="span" :to="{path:'/interface/zshhd'}" class="cursor-pointer color-black-1" type="span">子商户回调</router-link>
          】【这步可以忽略】<br />
        </p>
        <div>
          <h4>支付公司提供了H5进件</h4>
          <p>H5URL：https://mcht.yunfastpay.com/html#/mcht_protocol?orgCd=机构号&chnlCd=sxf&outMchtCd=商户在业务系统的编号&sign=签名</p>
          <p> 签名规则：MD5(orgCd=机构号&chnlCd=sxf&outMchtCd=商户在业务系统的编号&机构秘钥前6位)</p>
        </div>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM0201</td></tr>
          <tr><td>组织机构代码</td><td>orgCd</td><td>String（15）</td><td>是</td><td></td></tr>
          <tr><td>商户全称</td><td>mchtName</td><td>String（150）</td><td>是</td><td></td></tr>
          <tr><td>角色</td><td>mchtRole</td><td>String（3）</td><td>是</td><td>固定600:商户</td></tr>
          <tr><td>商户简称</td><td>mchtCnAbbr</td><td>String（60）</td><td>是</td><td></td></tr>
          <tr><td>商户拼音缩写</td><td>spellName</td><td>String（30）</td><td>否</td><td></td></tr>
          <tr><td>商户级别</td><td>mchtLvl</td><td>String（1）</td><td>否</td><td></td></tr>
          <tr><td>联系人姓名</td><td>contact</td><td>String（30）</td><td>是</td><td></td></tr>
          <tr><td>联系人类型</td><td>contactClass</td><td>String（30）</td><td>是</td><td>取值范围{LEGAL_PERSON ：法人；CONTROLLER：实际控制人；AGENT ：代理人；OTHER ：其他；}</td></tr>
          <tr><td>联系人电子邮箱</td><td>commEmail</td><td>String（40）</td><td>否</td><td></td></tr>
          <tr><td>联系人客户电话</td><td>commMobil</td><td>String（20）</td><td>是</td><td></td></tr>
          <tr><td>联系人电话</td><td>commTel</td><td>String（20）</td><td>是</td><td></td></tr>
          <tr><td>联系人地址</td><td>commAddr</td><td>String（386）</td><td>否</td><td></td></tr>
          <tr><td>法人姓名</td><td>manager</td><td>String（50）</td><td>是</td><td></td></tr>
          <tr><td>法人证件类型</td><td>artifCertifTp</td><td>String（2）</td><td>是</td><td>身份证：00护照:01</td></tr>
          <tr><td>法人证件号码</td><td>identityNo</td><td>String（20）</td><td>否</td><td>企业必填</td></tr>
          <tr><td>法人证件有效期开始</td><td>identityNoBeginDate</td><td>String（8）</td><td>是</td><td>格式yyyyMMdd</td></tr>
          <tr><td>法人证件有效期截止</td><td>identityNoEndDate</td><td>String（8）</td><td>是</td><td>格式yyyyMMdd</td></tr>
          <tr><td>法人联系电话</td><td>managerTel</td><td>String（12）</td><td>是</td><td>企业必填</td></tr>
          <tr><td>证件类型</td><td>licenseType</td><td>String（32）</td><td>是</td><td>证件类型（取值范围：NATIONAL_LEGAL 营业执照;NATIONAL_LEGAL_MERGE 营业执照多证合一；INST_RGST_CTF 事业单位法人证书NATIONAL_IDENTITY身份证）企业必填</td></tr>
          <tr><td>商户证件编号号码</td><td>licenceNo</td><td>String（20）</td><td>否</td><td>企业，个体户必填</td></tr>
          <tr><td>商户证件有效期</td><td>licenceBeginDate</td><td>String（8）</td><td>否</td><td>企业，个体户必填</td></tr>
          <tr><td>商户证件有效期</td><td>licenceEndDate</td><td>String（8）</td><td>否</td><td>企业，个体户必填</td></tr>
          <tr><td>商户邮箱</td><td>mchtEmail</td><td>String（100）</td><td>是</td><td></td></tr>
          <tr><td>邮编</td><td>postCode</td><td>String（6）</td><td>否</td><td></td></tr>
          <tr><td>区域代码</td><td>areaNo</td><td>String（6）</td><td>是</td><td></td></tr>
          <tr><td>注册地址</td><td>regAddr</td><td>String（60）</td><td>是</td><td>个人填住址</td></tr>
          <tr><td>营业性质</td><td>busType</td><td>String（60）</td><td>是</td><td>1：个体资质 2： 企业资质 3：自然人</td></tr>
          <tr><td>经营范围</td><td>mchtScope</td><td>String（60）</td><td>否</td><td>企业，个体户必填</td></tr>
          <tr><td>税务登记证号码</td><td>faxNo</td><td>String（20）</td><td>否</td><td></td></tr>
          <tr><td>注册资金</td><td>busAmt</td><td>String（12）</td><td>否</td><td></td></tr>
          <tr><td>企业资质等级</td><td>mchtCreLvl</td><td>String（4）</td><td>否</td><td></td></tr>
          <tr><td>协议编号</td><td>protocalId</td><td>String（20）</td><td>否</td><td></td></tr>
          <tr><td>外部商户号</td><td>outMchtCd</td><td>String（15）</td><td>是</td><td></td></tr>
          <tr><td>商户一级分类</td><td>mchtLevel1No</td><td>String（12）</td><td>否</td><td></td></tr>
          <tr><td>商户二级分类</td><td>mchtLevel2No</td><td>String（12）</td><td>否</td><td></td></tr>
          <tr><td>省代码</td><td>provinceCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>市代码</td><td>cityCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>区代码</td><td>districtCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>清算行省代码</td><td>settleBankProvinceCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>清算行市代码</td><td>settleBankCityCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>结算人证件号</td><td>settleIdentityNo</td><td>String（10）</td><td>否</td><td>非法人结算部分通道必填。咨询技术</td></tr>
          <tr><td>结算人证件号有效期（始）</td><td>settleBeginDate</td><td>String（10）</td><td>否</td><td>非法人结算部分通道必填。咨询技术</td></tr>
          <tr><td>结算人证件号有效期（末）</td><td>settleEndDate</td><td>String（10）</td><td>否</td><td>非法人结算部分通道必填。咨询技术</td></tr>
          <tr><td>商户结算帐户开户总行</td><td>settleHeadBankNo</td><td>String（40）</td><td>是</td><td></td></tr>
          <tr><td>商户结算帐户开户行</td><td>settleBankNo</td><td>String（40）</td><td>是</td><td></td></tr>
          <tr><td>商户结算帐户开户行名称</td><td>settleBankNm</td><td>String（256）</td><td>是</td><td></td></tr>
          <tr><td>商户结算帐户号</td><td>settleAcct</td><td>String（40）</td><td>是</td><td></td></tr>
          <tr><td>商户结算帐户户名</td><td>settleAcctNm</td><td>String（256）</td><td>是</td><td></td></tr>
          <tr><td>账户类型</td><td>acctType</td><td>String（1）</td><td>是</td><td>1 ：对私,2： 对公</td></tr>
          <tr><td>开户地址</td><td>openAcctAddr</td><td>String（512）</td><td>是</td><td></td></tr>
          <tr><td>传真/微信账号</td><td>fax</td><td>String (64)</td><td>否</td><td>微信刷脸必填，其它可以不填</td></tr>
          <tr><td>阿里账号</td><td>aliNo</td><td>String (64)</td><td>否</td><td>支付宝刷脸必填，其它可以不填</td></tr>
          <tr><td>商户受益人信息</td><td>beneficiaryInfos</td><td>String (1024)</td><td>否</td><td>受益人信息json数组字符串</td></tr>
          <tr><td>-</td><td>orderNum</td><td>String (1)</td><td>是</td><td>受益人序号 1,2,3,4</td></tr>
          <tr><td>-</td><td>idDocType</td><td>String (32)</td><td>是</td><td>证件类型：身份证-RESIDENT_ID_CARD</td></tr>
          <tr><td>-</td><td>idDocName</td><td>String (50)</td><td>是</td><td>受益人姓名</td></tr>
          <tr><td>-</td><td>idDocNumber</td><td>String (32)</td><td>是</td><td>受益人证件号</td></tr>
          <tr><td>-</td><td>docPeriodBegin</td><td>String (8)</td><td>是</td><td>受益人证件有效期开始，格式yyyyMMdd</td></tr>
          <tr><td>-</td><td>docPeriodEnd</td><td>String (8)</td><td>是</td><td>受益人证件有效期结束，格式yyyyMMdd</td></tr>
          <tr><td>-</td><td>idDocAddress</td><td>String (100)</td><td>是</td><td>受益人证件地址</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String（15）</td><td>是</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Zshbj',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshcx', 'name': '子商户开通查询'},
        {'url': '/interface/zshbbcx', 'name': '子商户报备查询'},
        {'url': '/interface/zshfzxy', 'name': '子商户分账协议签署'},
        {'url': '/interface/zshpz', 'name': '子商户业务配置'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Zshbj.vue